import React, { useState } from 'react';
import { API_BASE_URL } from './config/socket';

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      // Fail closed: wenn /login nicht ans Backend weitergeleitet wird, liefert
      // nginx die index.html mit Status 200 zurueck -- das darf kein Login sein.
      const isJson = response.headers.get('content-type')?.includes('application/json');

      if (response.ok && isJson) {
        const data = await response.json();
        console.log(data.message);
        onLogin(password); // Passwort weiterreichen, RCON braucht es
      } else if (response.ok) {
        alert('Login-Endpunkt antwortet nicht korrekt - bitte Serverkonfiguration pruefen');
      } else {
        const error = await response.json();
        alert(error.message);
      }
    } catch (error) {
      console.error('Fehler beim Login:', error);
    }
  };

  return (
    <div>
      <h1>Admin Login</h1>
      <input
        type="password"
        placeholder="Passwort eingeben"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
};

export default AdminLogin;
